// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div>\n  <div data-translucent-background=true class=\"f-modal__modal-container brec-dialog__container\">\n    <div data-fake-tabbable=true tabindex=\"0\"></div> \n    <div inject=\"modal-content\"></div>\n    <div data-fake-tabbable=true tabindex=\"0\"></div> \n  </div>\n</div>\n";
},"useData":true});
